import { QueueRule } from '../../../rules/models/queueRule';
import { Url } from '../../../utils/codecUtils';
import {
  suggestTriggerConditionSummaryPayloadSchema,
  suggestTriggerConditionSummaryResponseSchema,
} from './suggestTriggerConditionSummary.schema';

export type SuggestTriggerConditionSummaryPayload = {
  userQuery?: string;
  schemaRule: Partial<QueueRule>;
  queue: Url;
};

export type SuggestTriggerConditionSummaryResult = {
  triggerCondition?: string;
  triggerConditionSummary?: string;
};

export type SuggestTriggerConditionSummaryResponse = {
  results: Array<SuggestTriggerConditionSummaryResult>;
};

export const suggestTriggerConditionSummary = (
  payload: SuggestTriggerConditionSummaryPayload
) =>
  ({
    endpoint: `/internal/rules/trigger_condition_summary `,
    method: 'POST',
    responseSchema: suggestTriggerConditionSummaryResponseSchema,
    payloadSchema: suggestTriggerConditionSummaryPayloadSchema,
    payload,
  }) as const;
